import apiClient from './api';

export type MeituanEnvironment = 'production' | 'sandbox';

export interface MeituanConfig {
  id?: string;
  enabled: boolean;
  environment: MeituanEnvironment;
  developerAccount: string;
  appSecret: string;
  shopAuthUrl: string;
  remark: string;
  createdBy?: string;
  updatedBy?: string;
  createdAt?: string;
  updatedAt?: string;
}

export const getMeituanConfig = async () => {
  const response = await apiClient.get<MeituanConfig>('/meituan-config');
  return response.data;
};

export const saveMeituanConfig = async (data: MeituanConfig) => {
  const response = await apiClient.put<MeituanConfig>('/meituan-config', data);
  return response.data;
};
